export * from './bounds'
export * from './search'
export * from './content_header'
export * from './detail/component_with_modal'
export * from './detail/category_selection'
export * from './detail/detail'
export * from './detail/location_selection'
export * from './detail/location_selection_button'
export * from './detail/project_results_container'
export * from './overview/location_search_button'
export * from './overview/overview'
export * from './overview/category'
export * from './overview/category_list'
export * from './overview/top_projects_container'
export * from './page'

import '../shared/translation_setup'
// this file is auto-generated. to update it
// with content from the yml files,
// restart server or run `rake i18n:js:export`
export * from './translations'
